module.exports = __webpack_public_path__ + "static/media/scan_fail_shorter.f1aa1d88.mp3";